// extracted by mini-css-extract-plugin
export default {"adminTeamBlock":"AdminTeam_adminTeamBlock__SWop+"};